import React from "react";

const AppLogo = ({ logo }) => {
  return <img src={logo} className="app-logo" alt="logo" />;
};

export default AppLogo;
